// @flow

export { getImageSourceFromBrand } from './get-source-from-brand';
